var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearningicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 21.75H10.25V23.3125H7.125V7.6875H5.5625V24.875H10.25V26.4375H4V6.125H7.125V4.5625H11.8125C12.5286 4.5625 13.2163 4.67236 13.8755 4.89209C14.5347 5.11182 15.1491 5.44141 15.7188 5.88086C16.2803 5.44141 16.8906 5.11182 17.5498 4.89209C18.209 4.67236 18.9007 4.5625 19.625 4.5625H24.3125V6.125H27.4375V16.1226L25.875 15.4146V7.6875H24.3125V14.7065L22.75 13.9863V6.125H19.625C19.0472 6.125 18.4938 6.22266 17.9648 6.41797C17.4359 6.61328 16.9476 6.90218 16.5 7.28467V14.7065L14.9375 15.4146V7.28467C14.498 6.91032 14.0138 6.62549 13.4849 6.43018C12.9559 6.23486 12.3984 6.13314 11.8125 6.125H8.6875V21.75ZM25.875 24.8628L20.4062 27.6094L14.9375 24.8628C14.9375 24.5698 14.9416 24.2606 14.9497 23.9351C14.9578 23.6095 14.9904 23.2799 15.0474 22.9463C15.1043 22.6126 15.1857 22.2993 15.2915 22.0063C15.3973 21.7134 15.5438 21.4408 15.731 21.1885L13.375 20.1143V27.2188H11.8125V19.4062L20.4062 15.5L29 19.4062L25.0815 21.1885L25.1792 21.3228C25.3501 21.575 25.4803 21.8477 25.5698 22.1406C25.6593 22.4336 25.7285 22.7306 25.7773 23.0317C25.8262 23.3328 25.8547 23.6421 25.8628 23.9595C25.8709 24.2769 25.875 24.578 25.875 24.8628ZM20.4062 17.209L15.5845 19.4062L20.4062 21.6035L25.228 19.4062L20.4062 17.209ZM20.4062 25.8638L24.3125 23.8984C24.3044 23.6868 24.2881 23.4956 24.2637 23.3247C24.2393 23.1538 24.1945 22.987 24.1294 22.8242C24.0643 22.6615 23.9992 22.5028 23.9341 22.3481C23.869 22.1935 23.7754 22.0226 23.6533 21.8354L20.4062 23.3125L17.1592 21.8354C17.0371 22.0308 16.9395 22.2057 16.8662 22.3604C16.793 22.515 16.7279 22.6696 16.6709 22.8242C16.6139 22.9788 16.5773 23.1416 16.561 23.3125C16.5448 23.4834 16.5285 23.6828 16.5122 23.9106L20.4062 25.8638Z",
    fill: "#27b74e"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_2",
    x: 0,
    y: -1,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.229167 0 0 0 0 0.229167 0 0 0 0 0.229167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_2",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningicon);
export default __webpack_public_path__ + "static/media/learningicon.33321ac7155364f928f8fb5e1b049d7c.svg";
export { ForwardRef as ReactComponent };